type WorkExperienceAnswer = { label: string; value: string }

const weeklyWorkloadHours: Array<WorkExperienceAnswer> = [
  { label: '<10', value: 'UNDER_10_HOURS' },
  { label: '11-20', value: '11_TO_20_HOURS' },
  { label: '21-30', value: '21_TO_30_HOURS' },
  { label: '31-40', value: '31_TO_40_HOURS' },
  { label: '40+', value: 'OVER_40_HOURS' },
]

const paroIncomeStatus: Array<WorkExperienceAnswer> = [
  { label: 'Working as a freelancer is my primary source of income', value: 'PRIMARY' },
  { label: 'I work part-time as a freelancer', value: 'SECONDARY_ADDITIONAL' },
  {
    label: 'I have a full-time day job and work as a freelancer as a secondary source of income',
    value: 'PART_TIME',
  },
]

const totalFreelanceExperience: Array<WorkExperienceAnswer> = [
  { label: 'Less than a year', value: 'UNDER_1_YEAR' },
  { label: '1-3 years', value: '1_TO_3_YEARS' },
  { label: '3-5 years', value: '3_TO_5_YEARS' },
  { label: '5 years or more', value: 'OVER_5_YEARS' },
]

const projectTypes: Array<WorkExperienceAnswer> = [
  { label: 'One-time projects', value: 'ONE_TIME' },
  { label: 'Recurring projects', value: 'RECURRING' },
  { label: 'Both', value: 'BOTH' },
]

const contactTimePreferences: Array<WorkExperienceAnswer> = [
  { label: 'Business Hours', value: 'BUSINESS_HOURS' },
  { label: 'Outside Business Hours', value: 'OUTSIDE_BUSINESS_HOURS' },
  { label: 'Anytime', value: 'ANY' },
]

const communicationMethods: Array<WorkExperienceAnswer> = [
  { label: 'Email', value: 'EMAIL' },
  { label: 'Phone', value: 'PHONE' },
  { label: 'Text', value: 'TEXT' },
  { label: 'Any', value: 'ANY' },
]

const weeklyHoursMapToMonthlyHours = {
  UNDER_10_HOURS: 40,
  '11_TO_20_HOURS': 60,
  '21_TO_30_HOURS': 100,
  '31_TO_40_HOURS': 140,
  OVER_40_HOURS: 160,
}

export {
  weeklyWorkloadHours,
  paroIncomeStatus,
  totalFreelanceExperience,
  projectTypes,
  contactTimePreferences,
  communicationMethods,
  weeklyHoursMapToMonthlyHours,
}
